// 주문 내역 빈 상태 컴포넌트
import { ShoppingBag } from 'lucide-react';
import type { OrderHistoryTranslations } from './types';

interface OrderHistoryEmptyStateProps {
  translations: OrderHistoryTranslations;
}

export function OrderHistoryEmptyState({ translations }: OrderHistoryEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mb-4">
        <ShoppingBag className="w-10 h-10 text-muted-foreground" />
      </div>
      <h3 className="text-base font-bold text-foreground mb-2">
        {translations.noOrders}
      </h3>
      <p className="text-sm text-muted-foreground">{translations.noOrdersDesc}</p>
    </div>
  );
}
